// import '@ungap/global-this';
import "core-js/stable";
import "regenerator-runtime/runtime";
import "@/confs/axios.conf.js";
import "@/confs/vue.conf.js";
import "@/confs/vue.golbal.components.js";
import "@/libs/grip.date.format.js";
import "@/assets/css/style.css";
// import "@/assets/css/style2.css";
import { $_WC } from "@/confs/common.const";

// 구글지도 라이브러리 attach
window.checkAndAttachMapScript = (callback) => {
    if (!!window.google) {  // If you're using vue cli, then directly checking
        // 'google' obj will throw an error at the time of transpiling.
        callback();
        return true;
    }

    window.mapApiInitialized = callback;
    let script = document.createElement('script');
    script.src = "https://maps.googleapis.com/maps/api/js?key=" + process.env.VUE_APP_GGL_MAP_KEY + "&libraries=places,geometry&callback=mapApiInitialized&region=KR";
    document.body.appendChild(script);
};

const defaultUser = {
    eno: 'CS510353',
    authGroupCode: 'SUPER',
    empNm: '슈퍼관리자',
    state: '1',
    dept1: '32202240000',
    dept2: '32202240000',
    username: 'CS510353',
    authorities: [
        {"authority": "ROLE_SUPER"},
    ],
    authGroupNm: "슈퍼관리자",
};


// 이전 로그인 체크
// window.fetchCurrentUser = async () => {
//     if(process.env.NODE_ENV !== 'production') {
//         return defaultUser
//     } else {
//         let res = await axios.get(process.env.VUE_APP_AUTHURL + "/currentUser")
//         return res.data;
//     }
// };

window.fetchCurrentUser = async () => {
    // local은 로그인 처리가 없으므로 별도 처리한다
    if(process.env.NODE_ENV !== 'local') {
        let res = await axios.get(process.env.VUE_APP_AUTHURL + '/currentAuth');
        let list = res.data.menuList;
        list = list.filter(d => {
            return d.menuSeq === -100;
        });
        list = list[0].subPageMenus;
        return {user: res.data.user, menuList: list};
    } else {
        let res = await axios.get(process.env.VUE_APP_APIBASEURL + '/menuList?authGroupCode=' + defaultUser.authGroupCode);

        // 대민은 -100인 메뉴만 사용
        let list = res.data.data;
        list = list.filter(d => {
            return d.menuSeq === -100;
        });
        list = list[0].subPageMenus;
        return {user: defaultUser, menuList: list};
    }
};

window.fetchPageRoller = async () => {
    let res = await axios.get(process.env.VUE_APP_APIBASEURL + "/repos/7/data")
    return res.data;
};

window.setMenus = (vue, menuList) => {
    let currentUrl = window.location.pathname;
    vue.$session.set('upperMenu', undefined);   // 상위메뉴 (상위가 없는 경우 현재메뉴와 동일)
    vue.$session.set('currentMenu', undefined); // 현재메뉴
    vue.$session.set('mainMenu', undefined);    // 메인메뉴
    // console.log( window.location.hash );
    menuList.forEach(menu => {
        if(menu.menuNm === '메인') {
            menu.menuNm = '홈';
        }
        let url = $_WC.cp + menu.menuUrl;
        if(!Array.isArray(menu.subPageMenus)) {
            if(url.indexOf(currentUrl) > -1) {
                vue.$session.set('upperMenu', menu);
                vue.$session.set('currentMenu', menu);
            }
        } else {
            for(let i = 0; i < menu.subPageMenus.length; i++){
                url = $_WC.cp + menu.subPageMenus[i].menuUrl;
                if(url.indexOf(currentUrl) > -1){
                    vue.$session.set('upperMenu', menu);
                    vue.$session.set('currentMenu', menu.subPageMenus[i]);
                }
            }
        }
        if(menu.menuSeq === $_WC.mainMenuSeq){
            vue.$session.set('mainMenu', menu);
        }
    });
    vue.$session.set('menuList', menuList); // 메뉴 리스트
};
